import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { Button, Card, Table } from 'antd'
import api from 'Common/Client/Interceptor'
import useServerPagination from 'Common/hooks/useServerPagination'

const TrainingDetail = () => {
  const token = localStorage.getItem('token')
  const { id } = useParams()
  const [groupDetail, setGroupDetail] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  // Group members were moved out of the parent detail response into a
  // separate paginated endpoint.
  const {
    items: members,
    loading: membersLoading,
    paginationProps,
  } = useServerPagination(({ pageNumber, pageSize, orderByLatest }) =>
    api
      .get('/TrainingGroup/Members/List', {
        params: { groupId: id, pageNumber, pageSize, orderByLatest },
      })
      .then((r) => r.data)
  )

  useEffect(() => {
    const fetchGroupDetail = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/TrainingGroup/Detail?GroupId=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        setGroupDetail(response.data)
      } catch (error) {
        console.error('Error fetching group details:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchGroupDetail()
  }, [id])

  const columns = [
    {
      title: 'Learner ID',
      dataIndex: 'learnerId',
      key: 'learnerId',
    },
    {
      title: 'Learner Name',
      dataIndex: 'learnerName',
      key: 'learnerName',
    },
    {
      title: "Business Group Name",
      dataIndex: "businessGroupName",
      render: (text) => (text ? text : "N/A"),
    },
  ]

  return (
    <Card
      title="Training Detail"
      className="card-professional"
      loading={loading}
      extra={
        <Button type="default" onClick={() => navigate('/training-list')}>
          Back
        </Button>
      }
    >
      {groupDetail ? (
        <>
          <p>
            <strong>Group Name:</strong> {groupDetail.groupName}
          </p>
          <p>
            <strong>Mentor Name:</strong> {groupDetail.mentorName}
          </p>
          <p>
            <strong>Created On:</strong> {new Date(groupDetail.createdOn).toLocaleString()}
          </p>
          <h3>Group Members</h3>
          <Table
            dataSource={members}
            loading={membersLoading}
            columns={columns}
            rowKey="id"
            pagination={paginationProps}
            scroll={{ x: "max-content" }}
          />
        </>
      ) : (
        <p>No group details found.</p>
      )}
    </Card>
  )
}

export default TrainingDetail
